"use strict";function chooseImage$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.chooseImage$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.chooseImage";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.1"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.1"},_a)),exports.chooseImage$=chooseImage$,exports.default=chooseImage$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/chooseImage.js
// module id = 1000
// module chunks = 106